// Stripe billing API client for AtomicEdu.
import { authApi } from "./auth";

export const fetchTiers = async () => {
  const { data } = await authApi.get("/billing/tiers");
  return data;
};

export const fetchMyBilling = async () => {
  const { data } = await authApi.get("/billing/me");
  return data;
};

export const startCheckout = async ({ tier_id, billing_period }) => {
  const { data } = await authApi.post("/billing/checkout", {
    tier_id,
    billing_period,
    origin_url: window.location.origin,
  });
  return data; // { url, session_id }
};

export const openBillingPortal = async () => {
  const { data } = await authApi.post("/billing/portal", {
    origin_url: window.location.origin,
  });
  return data; // { url }
};

export const fetchInvoices = async (limit = 3) => {
  const { data } = await authApi.get("/billing/invoices", { params: { limit } });
  return data; // { invoices: [...], has_stripe_customer: bool }
};
